import getHostNameFromURL from './getHostNameFromURL'

const extractDomainFromURL = (url: string): string | null => {
  const hostName = getHostNameFromURL(url)
  let domain = hostName
  if (hostName != null) {
    const parts = hostName.split('.').reverse()
    if (parts != null && parts.length > 1) {
      domain = `${parts[1]}.${parts[0]}`
      if (hostName.toLowerCase().includes('.co.uk') && parts.length > 2) {
        domain = `${parts[2]}.${domain}`
      }
    }
    if (domain !== null) {
      domain = domain.split('.')[0]
    }
  }
  return domain
}

export default extractDomainFromURL
